import { useTranslation } from "react-i18next";
import { FOOTER_HEIGHT } from "@/common/constants/layout";

export default function CopyrightFooter() {
	const { t } = useTranslation();
	return (
		<footer
			style={{ height: FOOTER_HEIGHT }}
			className="flex-shrink-0 z-50 py-4 text-sm text-center text-muted-foreground bg-transparent"
		>
			{t("footer.copyright")}
		</footer>
	);
}
